// Wrapper around chance library so we can control the seed globally
import Chance from 'chance';

const chance = new Chance();

export default chance;



// WEBPACK FOOTER //
// ./src/helpers/chance.js